/* Prime Outlet (v13) */

/* 0. Ajustes de estilo que dependen del markup de las tarjetas:
      el "Oferta" se oculta porque el % de descuento ya aparece junto al precio
      y así no tapa el logo de la marca.
      Carrito lateral: la X de cerrar queda completa dentro de la cabecera roja (antes salía 10px por la derecha).
      v13 (2026-10-24): carrito lateral más ancho (500px), cabecera y barra de envío más delgadas y sin negrita,
      letras más pequeñas, botones "Ir al carrito" + "Pagar pedido", precio Yape / tarjeta al estilo de la ficha,
      "Completa tu compra" y barra de anuncios superior sin negrita. */
(function () {
  var s = document.createElement('style');
  s.textContent = '.card-wrapper .card__badge .badge.color-scheme-4{display:none!important}' +
    'cart-drawer .drawer__header{position:relative}' +
    'cart-drawer .drawer__close{right:6px!important;top:50%!important;transform:translateY(-50%);color:#fff!important}' +
    /* Carrito lateral: "S/." a la misma altura y tamaño que el precio, sin partir la línea */
    'cart-drawer .price-symbol{position:static!important;top:0!important;vertical-align:baseline!important;font-size:1em!important;margin-right:3px!important}' +
    'cart-drawer .cart-item__totals .price,cart-drawer .cart-item__old-price,cart-drawer .cart-item__final-price,cart-drawer .product-option,cart-drawer .totals__total-value,cart-drawer s{white-space:nowrap}' +

    /* v13 · Barra de anuncios superior en letra normal */
    '.po-anuncios,.po-anuncios *{font-weight:400!important}' +

    /* v13 · Ancho del carrito lateral */
    'cart-drawer .drawer__inner{width:500px!important;max-width:100vw!important}' +

    /* v13 · Cabecera roja y barra amarilla más delgadas, sin negrita */
    'cart-drawer .drawer__header{padding:7px 14px 7px 20px!important}' +
    'cart-drawer .drawer__heading{font-size:1.5rem!important;font-weight:400!important;letter-spacing:.3px!important;margin:0!important}' +
    'cart-drawer .drawer__close{width:3.2rem!important;height:3.2rem!important}' +
    'cart-drawer .po-envio{padding:5px 20px 6px!important;font-size:1.15rem!important;font-weight:400!important;line-height:1.35!important}' +
    'cart-drawer .po-envio strong{font-weight:400!important}' +
    'cart-drawer .po-envio__bar{height:3px!important;margin-top:4px!important}' +
    'cart-drawer .po-envio__bar span{height:3px!important}' +

    /* v13 · Letras más pequeñas y suaves */
    'cart-drawer .drawer__contents{padding:0 20px}' +
    'cart-drawer .cart-item__name{font-size:1.25rem!important;font-weight:500!important;line-height:1.4!important;color:#0F1111!important}' +
    'cart-drawer .cart-item__details > p.caption-with-letter-spacing{font-size:1rem!important}' +
    'cart-drawer .cart-item .product-option,cart-drawer .cart-item__price-wrapper .price{font-size:1.25rem!important}' +
    'cart-drawer .cart-items thead th{font-size:1rem!important;opacity:.7}' +
    'cart-drawer .tax-note{font-size:1.1rem!important;color:#565959!important;line-height:1.4!important}' +
    'cart-drawer .drawer__footer{padding:12px 20px 16px!important}' +

    /* v13 · Precio Yape / tarjeta (mismo estilo que la ficha de producto) */
    'cart-drawer .cart-drawer__footer .totals{display:none!important}' +
    '.po-cpr{display:grid;gap:8px;margin:0 0 6px;font-family:"DM Sans",Poppins,sans-serif;color:#13213f;letter-spacing:.6px}' +
    '.po-cpr__fila{display:grid;grid-template-columns:auto auto 1fr;align-items:center;gap:10px}' +
    '.po-cpr__monto{font-family:"Barlow Condensed",sans-serif;line-height:1;letter-spacing:normal;min-width:112px;white-space:nowrap}' +
    '.po-cpr__monto sup{font-size:.45em;vertical-align:top;position:relative;top:.15em;margin:0 1px}' +
    '.po-cpr__monto--yape{font-size:3.4rem;color:#d62839}' +
    '.po-cpr__monto--tarjeta{font-size:2.6rem;color:#13213f}' +
    '.po-cpr__tag{font-family:"Barlow Condensed",sans-serif;font-weight:700;font-size:1.4rem;padding:3px 8px 3px 11px;border-radius:0 4px 4px 0;clip-path:polygon(8px 0,100% 0,100% 100%,8px 100%,0 50%);white-space:nowrap}' +
    '.po-cpr__tag--rojo{background:#d62839;color:#fff}' +
    '.po-cpr__tag--amarillo{background:#FFD814;color:#13213f}' +
    '.po-cpr__lbl{font-size:1.35rem;font-weight:600;line-height:1.3}' +
    '.po-cpr__lbl small{display:block;font-size:1.15rem;font-weight:400;color:#6b7280}' +
    '.po-cpr__codigo{font-weight:600;font-size:1.05rem;color:#d62839;border:1.5px solid #d62839;border-radius:4px;padding:0 4px}' +
    '.po-extras__cuotas{margin:0 0 8px!important;font-size:1.15rem!important;text-align:left!important}' +

    /* v13 · Botones "Ir al carrito" + "Pagar pedido" */
    'cart-drawer .cart__ctas{display:grid!important;grid-template-columns:1fr 1.6fr;gap:10px}' +
    'cart-drawer .cart__ctas .cart__checkout-button{font-size:1.35rem!important;min-height:4.4rem!important}' +
    '.po-ir-carrito{display:flex;align-items:center;justify-content:center;min-height:4.4rem;border:1.5px solid #0F1111;border-radius:40px;color:#0F1111;font-size:1.35rem;font-weight:600;text-decoration:none;background:#fff}' +
    '.po-ir-carrito:hover{background:#F6F7F9}' +

    /* v13 · Completa tu compra */
    '.po-rel{margin-top:16px;border-top:1px solid #e7e7e7;padding-top:12px}' +
    '.po-rel__t{margin:0 0 10px;font-size:1.3rem;font-weight:600;text-align:center}' +
    '.po-rel__wrap{position:relative}' +
    '.po-rel__list{display:grid;grid-auto-flow:column;grid-auto-columns:calc((100% - 20px)/3);gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding-bottom:2px}' +
    '.po-rel__list::-webkit-scrollbar{display:none}' +
    '.po-rel__card{scroll-snap-align:start;border:1px solid #e7e7e7;border-radius:10px;padding:8px;display:flex;flex-direction:column;gap:5px;background:#fff;text-align:left}' +
    '.po-rel__img{display:block;aspect-ratio:1;border-radius:6px;background:#f6f6f6;overflow:hidden}' +
    '.po-rel__img img{width:100%;height:100%;object-fit:contain}' +
    '.po-rel__n{font-size:1.1rem;line-height:1.35;height:3rem;overflow:hidden;color:#0F1111;text-decoration:none}' +
    '.po-rel__p{font-size:1.2rem;font-weight:600;color:#E53935}' +
    '.po-rel__btn{margin-top:auto;border:1px solid #0F1111;background:#fff;border-radius:40px;padding:6px;font:inherit;font-size:1.1rem;font-weight:500;cursor:pointer;color:#0F1111}' +
    '.po-rel__btn:hover{background:#FFD814;border-color:#FFD814}' +
    '.po-rel__btn[disabled]{opacity:.5;cursor:default}' +
    '.po-rel__nav{position:absolute;top:35%;width:26px;height:26px;border-radius:50%;border:1px solid #ddd;background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.1);font-size:14px;line-height:1;color:#565959;cursor:pointer;padding:0}' +
    '.po-rel__nav--izq{left:-10px}.po-rel__nav--der{right:-10px}' +
    '@media (max-width:749px){.po-rel__list{grid-auto-columns:calc((100% - 10px)/2.3)}}';
  document.head.appendChild(s);
  /* Fuentes de los precios (las mismas de la ficha de producto), por si la página no las cargó */
  if (!document.querySelector('link[data-po-fuentes]')) {
    var f = document.createElement('link');
    f.rel = 'stylesheet';
    f.setAttribute('data-po-fuentes', '');
    f.href = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;700&family=DM+Sans:wght@400;600&display=swap';
    document.head.appendChild(f);
  }
})();

/* 1. Abre el mega menú al pasar el cursor (solo escritorio con mouse) */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    nav.querySelectorAll(':scope > ul > li').forEach(function (li) {
      var d = li.querySelector('details');
      if (!d) return;
      var s = d.querySelector('summary');
      var t;
      var byHover = false;
      function abrir() {
        nav.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        if (!d.open) { d.open = true; byHover = true; }
      }
      li.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(t);
        t = setTimeout(abrir, 90);
      });
      li.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(t);
        t = setTimeout(function () { d.open = false; byHover = false; }, 160);
      });
      s.addEventListener('click', function (e) {
        if (mq.matches && byHover && d.open) { e.preventDefault(); byHover = false; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 2. Carrito lateral: barra de envío gratis, precio Yape / tarjeta, cuotas, botón "Ir al carrito"
      y "Completa tu compra" */
(function () {
  var UMBRAL_ENVIO = 49900;  /* S/ 499.00 en céntimos */
  var UMBRAL_CUOTAS = 50000; /* S/ 500.00 */
  var DSCTO = 0.045;         /* código YAPE2 */
  var timer = null;
  var relCache = {};
  function soles(c) {
    return 'S/ ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function monto(c) {
    var t = (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).split('.');
    return '<sup>S/</sup>' + t[0] + '<sup>' + t[1] + '</sup>';
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function render(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    inner.querySelectorAll('.po-envio, .po-extras, .po-cpr, .po-ir-carrito, .po-rel').forEach(function (el) { el.remove(); });
    if (!cart || !cart.item_count) return;
    var total = cart.total_price;

    /* Barra de envío gratis */
    var head = inner.querySelector('.drawer__header');
    if (head) {
      var pct = Math.min(100, Math.round((total * 100) / UMBRAL_ENVIO));
      var bar = document.createElement('div');
      bar.className = 'po-envio' + (total >= UMBRAL_ENVIO ? ' po-envio--ok' : '');
      bar.innerHTML = (total >= UMBRAL_ENVIO
        ? '¡Genial! Tu pedido tiene ENVÍO GRATIS'
        : 'Te faltan ' + soles(UMBRAL_ENVIO - total) + ' para el envío gratis') +
        '<span class="po-envio__bar"><span style="width:' + pct + '%"></span></span>';
      head.insertAdjacentElement('afterend', bar);
    }

    /* Precio Yape / tarjeta en lugar de "Total estimado" */
    var liq = !!inner.querySelector('.po-liq-aviso');
    var foot = inner.querySelector('.cart-drawer__footer');
    var tax = foot && foot.querySelector('.tax-note');
    if (foot) {
      var pr = document.createElement('div');
      pr.className = 'po-cpr';
      if (liq) {
        pr.innerHTML = '<div class="po-cpr__fila"><span class="po-cpr__monto po-cpr__monto--yape">' + monto(total) + '</span><span></span>' +
          '<span class="po-cpr__lbl">Total a pagar<small>Yape, Plin o transferencia (incluye liquidación)</small></span></div>';
      } else {
        var yape = Math.round(total * (1 - DSCTO));
        pr.innerHTML =
          '<div class="po-cpr__fila"><span class="po-cpr__monto po-cpr__monto--yape">' + monto(yape) + '</span>' +
          '<span class="po-cpr__tag po-cpr__tag--rojo">-4.5%</span>' +
          '<span class="po-cpr__lbl">Transferencia, Yape o Plin<small>con el código <span class="po-cpr__codigo">YAPE2</span> · ahorras ' + soles(total - yape) + '</small></span></div>' +
          '<div class="po-cpr__fila"><span class="po-cpr__monto po-cpr__monto--tarjeta">' + monto(total) + '</span>' +
          '<span class="po-cpr__tag po-cpr__tag--amarillo">Total</span>' +
          '<span class="po-cpr__lbl">Precio tarjeta<small>Visa, Mastercard, Amex, Diners</small></span></div>';
      }
      if (tax) tax.insertAdjacentElement('beforebegin', pr); else foot.appendChild(pr);
    }

    /* Cuotas sin interés */
    var ctas = inner.querySelector('.cart__ctas');
    if (ctas && !liq && total >= UMBRAL_CUOTAS) {
      var ex = document.createElement('div');
      ex.className = 'po-extras';
      ex.innerHTML = '<p class="po-extras__cuotas">o 3 cuotas de <strong>' + soles(Math.round(total / 3)) + '</strong> sin interés con tarjeta</p>';
      ctas.insertAdjacentElement('beforebegin', ex);
    }

    /* Botón "Ir al carrito" junto a "Pagar pedido" */
    if (ctas) {
      var a = document.createElement('a');
      a.className = 'po-ir-carrito';
      a.href = root() + 'cart';
      a.textContent = 'Ir al carrito';
      ctas.insertAdjacentElement('afterbegin', a);
    }

    /* Completa tu compra */
    var footer = inner.querySelector('.drawer__footer');
    if (footer) relacionados(cart, footer);
  }

  function relacionados(cart, footer) {
    var enCarrito = {};
    cart.items.forEach(function (i) { enCarrito[i.product_id] = true; });
    var pid = cart.items[0].product_id;
    var cont = document.createElement('div');
    cont.className = 'po-rel';
    cont.hidden = true;
    footer.appendChild(cont);
    var p = relCache[pid] || fetch(root() + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
    relCache[pid] = p;
    p.then(function (prods) {
      var lista = prods.filter(function (x) { return x.available && !enCarrito[x.id] && x.variants && x.variants.length; }).slice(0, 8);
      if (!lista.length || !cont.isConnected) return;
      var h = '<p class="po-rel__t">Completa tu compra</p><div class="po-rel__wrap"><div class="po-rel__list">';
      lista.forEach(function (x) {
        var v = x.variants.filter(function (vv) { return vv.available; })[0] || x.variants[0];
        var img = x.featured_image ? x.featured_image + (x.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        h += '<div class="po-rel__card">' +
          '<a class="po-rel__img" href="' + x.url + '">' + (img ? '<img src="' + img + '" alt="' + esc(x.title) + '" loading="lazy" width="120" height="120">' : '') + '</a>' +
          '<a class="po-rel__n" href="' + x.url + '">' + esc(x.title) + '</a>' +
          '<span class="po-rel__p">' + soles(v.price) + '</span>' +
          '<button type="button" class="po-rel__btn" data-po-add="' + v.id + '">Agregar</button></div>';
      });
      h += '</div><button type="button" class="po-rel__nav po-rel__nav--izq" aria-label="Anterior">‹</button>' +
        '<button type="button" class="po-rel__nav po-rel__nav--der" aria-label="Siguiente">›</button></div>';
      cont.innerHTML = h;
      cont.hidden = false;
    });
  }

  /* Agregar desde "Completa tu compra" y flechas del carrusel */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.po-rel__nav');
    if (nav) {
      var list = nav.parentElement.querySelector('.po-rel__list');
      list.scrollBy({ left: (nav.classList.contains('po-rel__nav--izq') ? -1 : 1) * list.clientWidth, behavior: 'smooth' });
      return;
    }
    var btn = e.target.closest('[data-po-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.textContent = 'Agregando…';
    var drawer = document.querySelector('cart-drawer');
    var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.dataset.poAdd, quantity: 1 }], sections: secciones, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { btn.textContent = 'Sin stock'; return; }
      if (drawer && drawer.renderContents && res.sections) {
        res.id = res.items ? res.items[0].id : res.id;
        drawer.renderContents(res);
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'po-rel' });
      refresh();
    }).catch(function () { btn.disabled = false; btn.textContent = 'Agregar'; });
  });

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 200);
  }
  window.poCarritoRefresh = refresh;
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    refresh();
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    new MutationObserver(function () {
      if (!drawer.querySelector('.po-envio') && !drawer.classList.contains('is-empty')) refresh();
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 3. v13.6: carga la búsqueda instantánea y "Vistos recientemente" (assets/po-busqueda-vistos.js) */
(function () {
  var actual = document.currentScript || document.querySelector('script[src*="prime-outlet.js"]');
  if (!actual || !actual.src) return;
  var s = document.createElement('script');
  s.src = actual.src.split('?')[0].replace(/prime-outlet\.js$/, 'po-busqueda-vistos.js') + '?v=20261025c';
  s.defer = true;
  document.head.appendChild(s);
})();
